<template>
    <div id="banner-712">
      <div class="cs-container">
        <span class="cs-int-title">{{ title }}</span>
      </div>
      <!--Background Image-->
      <picture class="cs-background">
        <!--Mobile Image-->
        <source media="(max-width: 600px)" :srcset="imageSrc">
        <!--Tablet and above Image-->
        <source media="(min-width: 601px)" :srcset="imageSrc">
        <img loading="lazy" decoding="async" :src="imageSrc" :alt="altText" width="1280" height="568" aria-hidden="true">
      </picture>
    </div>
  </template>
  
  <script>
  export default {
    name: "PageBanner",
    props: {
      title: {
        type: String,
        required: true
      },
      imageSrc: {
        type: String,
        required: true
      },
      altText: {
        type: String,
        default: "background image"
      }
    }
  };
  </script>
  
  <style scoped>
  /*-- -------------------------- -->
<---          Banner            -->
<--- -------------------------- -*/

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
#banner-712 {
    height: 20vh; /* Restrict banner height to 70% of viewport */
    max-height: 20vh;
    padding: clamp(10.9375rem, 10vw, 12.5rem) 1rem 6.25rem;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}
#banner-712 .cs-container {
    text-align: center;
    width: 100%;
    max-width: 80rem;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
}
#banner-712 .cs-int-title {
    font-size: clamp(2.4375rem, 6.4vw, 3.8125rem);
    font-weight: 900;
    line-height: 1.2em;
    text-align: inherit;
    margin: 0;
    color: var(--bodyTextColorWhite);
    position: relative;
}
#banner-712 .cs-background {
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
}
#banner-712 .cs-background:before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    background: var(--primary);
    opacity: 0.75;
    top: 0;
    left: 0;
    z-index: 1;
}
#banner-712 .cs-background img {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
}
}

/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
#banner-712 .cs-background:before {
    opacity: 1;
    background: linear-gradient(
    90.01deg,
    rgba(90, 46, 152, 0.9) 16.86%,
    rgba(90, 46, 152, 0) 100%
);
}
}
  </style>
  